if (!customElements.get('premium-page')) {
  class PremiumPage extends HTMLElement {
    connectedCallback() {
      this.sliderCleanups = [];
      const schedule = () => {
        const time = Date.now();
        const released = time >= Date.parse('2026-11-18T10:00:00+09:00');
        const visible = {before:!released, after:released, ginza:time < Date.parse('2026-12-23T10:00:00+09:00'), umeda:time < Date.parse('2026-12-29T10:00:00+09:00')};
        this.querySelectorAll('[data-premium-period]').forEach(el => {el.hidden = !visible[el.dataset.premiumPeriod];});
        const temporaryShops = this.querySelector('.premium__temporary-shops');
        if (temporaryShops) {
          const visibleCount = temporaryShops.querySelectorAll('.premium__shop-card:not([hidden])').length;
          temporaryShops.classList.toggle('premium__temporary-shops--empty', visibleCount === 0);
          temporaryShops.classList.toggle('premium__temporary-shops--single', visibleCount === 1);
        }
      };
      schedule();
      this.scheduleTimer = setInterval(schedule, 1000);
      const menu = this.querySelector('.premium__menu');
      const menuLinks = [...menu.querySelectorAll('.premium__menu-link')];
      this.updateMenu = () => {
        const header = document.querySelector('.shopify-section-header-sticky, .section-header');
        const rect = header?.getBoundingClientRect();
        const fixed = header && ['sticky','fixed'].includes(getComputedStyle(header).position);
        const top = fixed && rect.bottom > 0 ? Math.min(rect.bottom, rect.height) : 0;
        this.style.setProperty('--premium-menu-top', `${top}px`);
        this.style.setProperty('--premium-header-offset', `${top + menu.offsetHeight + 16}px`);
        const boundary = Math.max(top + menu.offsetHeight + 20, window.innerHeight * 0.25);
        let active = menuLinks[0];
        menuLinks.forEach(link => {
          const section = this.querySelector(link.getAttribute('href'));
          if (section && section.getBoundingClientRect().top <= boundary) active = link;
        });
        menuLinks.forEach(link => {
          if (link === active) link.setAttribute('aria-current', 'location');
          else link.removeAttribute('aria-current');
        });
      };
      window.addEventListener('scroll', this.updateMenu, {passive:true});
      window.addEventListener('resize', this.updateMenu);
      this.updateMenu();
      this.querySelectorAll('.premium__gallery').forEach(gallery => {
        const track = gallery.querySelector('.premium__slider');
        const originals = [...track.children];
        const count = originals.length;
        const clones = [originals[count - 1].cloneNode(true), originals[0].cloneNode(true)];
        clones.forEach(clone => clone.setAttribute('aria-hidden', 'true'));
        track.prepend(clones[0]); track.append(clones[1]);
        const slides = [...track.children];
        originals.forEach((slide, i) => slide.setAttribute('aria-label', `${i + 1} / ${count}`));
        const media = window.matchMedia('(max-width: 749px)');
        let index = 1;
        let timer;
        const center = i => slides[i].offsetLeft - track.offsetLeft - (track.clientWidth - slides[i].clientWidth) / 2;
        const move = (i, smooth = true) => {
          index = Math.max(0, Math.min(slides.length - 1, i));
          track.scrollTo({left:center(index), behavior:smooth && !window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'instant'});
        };
        const click = event => {
          const button = event.target.closest('.premium__slider-button');
          if(button) move(index + Number(button.dataset.step));
        };
        const keydown = event => {
          if(event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          move(index + (event.key === 'ArrowRight' ? 1 : -1));
        };
        const scroll = () => {
          clearTimeout(timer);
          timer = setTimeout(() => {
            index = slides.reduce((best, slide, i) => Math.abs(center(i) - track.scrollLeft) < Math.abs(center(best) - track.scrollLeft) ? i : best, 0);
            if (index === 0) move(count, false);
            else if (index === count + 1) move(1, false);
            gallery.querySelector('.premium__slider-status').textContent = `${index} / ${count}`;
          }, 120);
        };
        const resize = () => { if(media.matches) move(index, false); };
        const observer = new ResizeObserver(resize);
        observer.observe(track);
        gallery.addEventListener('click', click);
        track.addEventListener('keydown', keydown);
        track.addEventListener('scroll', scroll, {passive:true});
        this.sliderCleanups.push(() => {
          observer.disconnect(); clearTimeout(timer); clones.forEach(clone => clone.remove());
          gallery.removeEventListener('click', click);
          track.removeEventListener('keydown', keydown);
          track.removeEventListener('scroll', scroll);
        });
      });
      this.onAnchorClick = (event) => {
        const link = event.target.closest('a[href^="#premium-"]');
        if (!link || !this.contains(link) || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        const target = this.querySelector(link.getAttribute('href'));
        if (!target) return;
        event.preventDefault();
        const header = document.querySelector('.section-header');
        this.updateMenu();
        const offset = parseFloat(this.style.getPropertyValue('--premium-header-offset')) || 16;
        this.style.setProperty('--premium-header-offset', `${offset}px`);
        target.focus({ preventScroll: true });
        const y = target.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top: y, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        history.replaceState(null, '', link.getAttribute('href'));
      };
      this.addEventListener('click', this.onAnchorClick);
    }
    disconnectedCallback() {
      clearInterval(this.scheduleTimer);
      window.removeEventListener('scroll', this.updateMenu);
      window.removeEventListener('resize', this.updateMenu);
      this.removeEventListener('click', this.onAnchorClick);
      this.sliderCleanups?.forEach(cleanup => cleanup());
    }
  }
  customElements.define('premium-page', PremiumPage);
}
